import indexState from "./indexStore/state";
import retrieveProjectSritState from "./retrieveProjectSrit/state";
import governmentState from "./government/state";
// 公有内容直接写入。
var state = {
    ...indexState,
    ...retrieveProjectSritState,
    ...governmentState
};
export default state;